import Head from 'next/head'
import merge from 'lodash/merge'
import { StyleObject, useStyletron } from 'styletron-react'
import { Header } from '@components/header'
import { Footer } from '@components/footer'
import { HEADER_HEIGHT } from '@styles/constants'

interface BasicLayoutOverrides {
  main?: {
    style?: StyleObject
  }
}

interface BasicLayoutProps {
  children?: React.ReactNode
  overrides?: BasicLayoutOverrides
  helmetTitle?: string
}

export const BasicLayout = ({
  children,
  overrides,
  helmetTitle,
}: BasicLayoutProps) => {
  const [css] = useStyletron()

  return (
    <>
      {helmetTitle && (
        <Head>
          <title>{helmetTitle}</title>
        </Head>
      )}
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          overflow: 'hidden',
        })}
      >
        <Header />
        <main
          className={css(
            merge<StyleObject, StyleObject>(
              {
                flex: '1 1 auto',
                overflowY: 'hidden',
                overflowX: 'hidden',
                position: 'relative',
                marginTop: HEADER_HEIGHT + 'px',
              },
              overrides?.main?.style || {}
            )
          )}
        >
          <div>{children}</div>
        </main>
        <Footer />
      </div>
    </>
  )
}
